<template>
    <div @click="closeOffcanvas">
        <router-link to="/admin/dashboard" class="nav-link d-flex align-items-center gap-2" active-class="active"
            v-tooltip="'Pulpit'" data-bs-placement="right">
            <i class="bi bi-speedometer2"></i>
            <span class="link-text">Pulpit</span>
        </router-link>

        <router-link to="/admin/websettings" class="nav-link d-flex align-items-center gap-2" active-class="active"
            v-tooltip="'Strona internetowa'" data-bs-placement="right" >
            <i class="bi bi-gear"></i>
            <span class="link-text">Strona internetowa</span>
        </router-link>

        <router-link to="/admin/settings" class="nav-link d-flex align-items-center gap-2" active-class="active"
            v-tooltip="'Ustawienia'" data-bs-placement="right" >
            <i class="bi bi-gear"></i>
            <span class="link-text">Ustawienia</span>
        </router-link>

        <router-link to="/admin/cars" class="nav-link d-flex align-items-center gap-2" active-class="active"
            v-tooltip="'Auta'" data-bs-placement="right" >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Auta</span>
        </router-link>
        <router-link to="/admin/publish" class="nav-link d-flex align-items-center gap-2" active-class="active"
            v-tooltip="'Multiwystawianie'" data-bs-placement="right" >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Multiwystawianie</span>
        </router-link>

        <router-link to="/admin/dealers" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Dealerzy'" data-bs-placement="right"
            >
            <i class="bi bi-person-badge"></i>
            <span class="link-text">Dealerzy</span>
        </router-link>
        <router-link to="/admin/packets" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Pakiety'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Pakiety</span>
        </router-link>
        <router-link to="/admin/generations" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Generacje'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Generacje</span>
        </router-link>
        <router-link to="/admin/models" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Modele'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Modele</span>
        </router-link>
        <router-link to="/admin/makes" v-if="userRole === 'admin_user'" class="nav-link d-flex align-items-center gap-2"
            active-class="active" v-tooltip="'Marki'" data-bs-placement="right" >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Marki</span>
        </router-link>
        <router-link to="/admin/colours" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Kolory'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Kolory</span>
        </router-link>
        <router-link to="/admin/equipment" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Wyposażenie'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Wyposażenie</span>
        </router-link>
        <router-link to="/admin/drivetypes" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Napędy'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Napędy</span>
        </router-link>
        <router-link to="/admin/fueltypes" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Paliwa'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Paliwa</span>
        </router-link>
        <router-link to="/admin/bodytypes" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Nadwozia'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Nadwozia</span>
        </router-link>
        <router-link to="/admin/gearboxes" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Skrzynie biegów'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Skrzynie biegów</span>
        </router-link>

        <router-link to="/admin/countries" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Państwa'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Państwa</span>
        </router-link>
        <router-link to="/admin/statuses" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Statusy'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Statusy</span>
        </router-link>
        <router-link to="/admin/dgenerator" 
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Szablony ogłoszeń'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Szablony ogłoszeń</span>
        </router-link>
        <router-link to="/admin/invoices" 
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Faktury'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Faktury</span>
        </router-link>
        <router-link to="/admin/depositcontract" 
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Umowy zadatku'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Umowy zadatku</span>
        </router-link>
       <router-link to="/admin/salecontract" 
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Umowy kupna - sprzedaży'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Umowy kup. - sprz.</span>
        </router-link>
      <router-link to="/admin/commisioncontract" 
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Umowy komisowe'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Umowy komisowe</span>
        </router-link>


        <router-link to="/admin/vatrates" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Stawki VAT'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Stawki VAT</span>
        </router-link>
        <router-link to="/admin/paymentstatuses" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Statusy płatności'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Statusy płatności</span>
        </router-link>
        <router-link to="/admin/paymenttypes" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Typy płatności'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Typy płatności</span>
        </router-link> 
        <router-link to="/admin/currencies" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Waluty'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Waluty</span>
        </router-link>
        <router-link to="/admin/vatexceptions" v-if="userRole === 'admin_user'"
            class="nav-link d-flex align-items-center gap-2" active-class="active" v-tooltip="'Wyjątki VAT'" data-bs-placement="right"
            >
            <i class="bi bi-car-front"></i>
            <span class="link-text">Wyjątki VAT</span>
        </router-link> 

    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import * as bootstrap from 'bootstrap'

const closeOffcanvas = () => {
    const closeBtn = document.querySelector('#mobileSidebar .btn-close')
    if (closeBtn) {
        closeBtn.click()
    }
}
// Reaktywna zmienna przechowująca rolę użytkownika
const userRole = ref('')

// Odczytujemy rolę z localStorage przy montowaniu komponentu
onMounted(() => {
    userRole.value = localStorage.getItem('user_role') || ''
})

// Customowa dyrektywa V-Tooltip
const vTooltip = {
  mounted(el, binding) {
    if (binding.value) {
      el.title = binding.value
      new bootstrap.Tooltip(el, { trigger: 'hover' })
    }
  },
  updated(el, binding) {
    const instance = bootstrap.Tooltip.getInstance(el)
    if (binding.value) {
      el.title = binding.value
      if (instance) {
        instance.setContent({ '.tooltip-inner': binding.value })
      } else {
        new bootstrap.Tooltip(el, { trigger: 'hover' })
      }
    }
  },
  unmounted(el) {
    const instance = bootstrap.Tooltip.getInstance(el)
    if (instance) {
      instance.dispose() // Czyszczenie pamięci
    }
  }
}
</script>
<style scoped>
.nav-pills .nav-link {
    border-radius: var(--bs-nav-pills-border-radius);
    border-bottom: 1px solid #888;
}

.nav-pills a span {
    color: var(--left-menu-color);
    font-weight: bold;
}

.nav-pills a i {
    color: var(--left-menu-color);
}

.nav-pills a {
    border-radius: 0 !important;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    background-color: var(--left-menu-selected-button);
    color: var(--left-menu-color-active);
}

.nav-pills .nav-link.active span,
.nav-pills .nav-link.active i,
.nav-pills .show>.nav-link {
    color: var(--left-menu-color-active);
}

.sidebar {
    width: 260px;
    min-width: 260px;
    height: 100vh;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-x: hidden;
}

.brand-icon {
    display: none;
}

.nav-link {
    white-space: nowrap;
    padding: 0.6rem 0.8rem;
}

.nav-link i {
    font-size: 1.2rem;
    min-width: 24px;
    text-align: center;
}

/* Stan Zzwinięty (Is Collapsed) */
.sidebar.is-collapsed {
    width: 70px;
    min-width: 70px;
}

.sidebar.is-collapsed .brand-text,
.sidebar.is-collapsed .link-text,
.sidebar.is-collapsed .user-info {
    display: none !important;
}

.sidebar.is-collapsed .brand-icon {
    display: inline-block;
}

.sidebar.is-collapsed .nav-link {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
}

.sidebar.is-collapsed .user-footer .d-flex {
    justify-content: center !important;
    flex-direction: column-reverse;
    gap: 0.5rem;
}
</style>